/**
 * ACT004 type=28 表单作用域（与控台 act004-form-scope-hotspot.js 对齐）
 */

import {
  pickAct004FormInputHotspotFields,
  pickAct004FormRadioHotspotFields,
  normalizeAct004FormRadioLayout,
  ensureAct004FormRadioOptionsForBind,
  isAct004FormRadioGroupBindField
} from '@/utils/act004-user-form-fields'

export function isAct004FormScopeHotspot(hotspot) {
  return String(hotspot && hotspot.type) === '28'
}

export function normalizeFormScopeKey(raw) {
  return String(raw == null ? '' : raw).trim().slice(0, 64)
}

export function normalizeFormScopeContentHeightRpx(raw, viewportHeightRpx) {
  const vh = Number.isFinite(parseInt(viewportHeightRpx, 10))
    ? Math.max(80, parseInt(viewportHeightRpx, 10))
    : 800
  const n = parseInt(raw, 10)
  if (!Number.isFinite(n)) return Math.max(vh, vh * 2)
  return Math.max(vh, Math.min(8000, n))
}

export function normalizeFormScopeBgImg(raw) {
  return raw == null ? '' : String(raw).trim()
}

export function normalizeFormScopeLayout(raw) {
  const s = String(raw || 'survey').trim().toLowerCase()
  if (s === 'absolute' || s === 'hotspot' || s === 'overlay') return 'absolute'
  return 'survey'
}

export function normalizeFormScopeIntroText(raw) {
  return String(raw == null ? '' : raw).trim().slice(0, 500)
}

export function normalizeFormScopeShowFieldIndex(raw) {
  if (raw === false || raw === 0 || raw === '0') return 0
  return 1
}

export function normalizeFormSubmitScope(raw) {
  const s = String(raw || 'page').trim().toLowerCase()
  if (s === 'activity') return 'activity'
  if (s === 'formscope' || s === 'form_scope' || s === 'scope') return 'formScope'
  return 'page'
}

function normalizeNestedOne(raw, i) {
  if (!raw || typeof raw !== 'object') return null
  const type = String(raw.type || '16').trim()
  if (type !== '16' && type !== '26') return null
  const left = parseFloat(raw.left)
  const top = parseFloat(raw.top)
  const sizeWidth = parseInt(raw.sizeWidth != null ? raw.sizeWidth : raw.size, 10)
  const sizeHeight = parseInt(raw.sizeHeight != null ? raw.sizeHeight : raw.size, 10)
  const indexRaw = parseInt(raw.index, 10)
  const base = {
    type,
    index: Number.isFinite(indexRaw) && indexRaw > 0 ? indexRaw : i + 1,
    name: String(raw.name || '').trim(),
    left: Number.isFinite(left) ? Math.max(0, Math.min(100, left)) : 50,
    top: Number.isFinite(top) ? Math.max(0, Math.min(100, top)) : 10,
    shape: 'rectangle',
    sizeWidth: Number.isFinite(sizeWidth) && sizeWidth > 0 ? Math.min(750, sizeWidth) : 600,
    sizeHeight: Number.isFinite(sizeHeight) && sizeHeight > 0 ? Math.min(2000, sizeHeight) : 80,
    size: Number.isFinite(sizeWidth) && sizeWidth > 0 ? Math.min(750, sizeWidth) : 600
  }
  if (type === '26') {
    return { ...base, ...pickAct004FormRadioHotspotFields(raw) }
  }
  const input = pickAct004FormInputHotspotFields(raw)
  if (isAct004FormRadioGroupBindField(input.userFieldBind)) {
    input.formRadioLayout = normalizeAct004FormRadioLayout(
      input.formRadioUiStyle === 'list' ? 'column' : raw.formRadioLayout
    )
    input.formRadioOptions = ensureAct004FormRadioOptionsForBind(
      input.userFieldBind,
      raw.formRadioOptions,
      { layout: input.formRadioLayout }
    )
  }
  return { ...base, ...input }
}

export function normalizeFormScopeNestedHotspots(list) {
  const src = Array.isArray(list) ? list : []
  const out = []
  src.forEach((raw, i) => {
    const row = normalizeNestedOne(raw, i)
    if (row) out.push(row)
  })
  return out
}

export function pickAct004FormScopeHotspotFields(raw) {
  const src = raw && typeof raw === 'object' ? raw : {}
  const sizeHeight = (() => {
    const n = parseInt(src.sizeHeight != null ? src.sizeHeight : src.size, 10)
    return Number.isFinite(n) && n > 0 ? Math.min(4000, n) : 800
  })()
  const sizeWidth = (() => {
    const n = parseInt(src.sizeWidth != null ? src.sizeWidth : src.size, 10)
    return Number.isFinite(n) && n > 0 ? Math.min(750, n) : 690
  })()
  return {
    formScopeKey: normalizeFormScopeKey(src.formScopeKey) || 'form_scope_1',
    formScopeLayout: normalizeFormScopeLayout(src.formScopeLayout),
    formScopeIntroText: normalizeFormScopeIntroText(src.formScopeIntroText),
    formScopeShowFieldIndex: normalizeFormScopeShowFieldIndex(src.formScopeShowFieldIndex),
    formScopeContentHeightRpx: normalizeFormScopeContentHeightRpx(src.formScopeContentHeightRpx, sizeHeight),
    formScopeBgImg: normalizeFormScopeBgImg(src.formScopeBgImg),
    formScopeNestedHotspots: normalizeFormScopeNestedHotspots(src.formScopeNestedHotspots),
    shape: 'rectangle',
    sizeWidth,
    sizeHeight,
    size: sizeWidth
  }
}

export function act004FormScopeDraftKey(scopeKey, hotspot) {
  const sk = normalizeFormScopeKey(scopeKey)
  const idx = hotspot && hotspot.index != null ? String(hotspot.index) : ''
  const bind = hotspot && hotspot.userFieldBind != null ? String(hotspot.userFieldBind).trim() : ''
  return `scope:${sk}:${idx}:${bind}`
}

export function act004FormScopeFieldBindDraftKey(scopeKey, bind) {
  const sk = normalizeFormScopeKey(scopeKey)
  const b = String(bind || '').trim().toLowerCase()
  return b ? `scope:${sk}:field:${b}` : ''
}
